// extracted by mini-css-extract-plugin
export default {"autoComplete":"TS-z","error":"US-z","disabled":"VS-z"};